export const red = {
    '50': '#FFEBEF',
    '100': '#FFCCD5',
    '200': '#FF7878',
    '300': '#F56A6A',
    '400': '#FA3D4D',
    '500': '#F8101D',
    '600': '#ED273C',
    '700': '#DB1A35',
    '800': '#CE0E2E',
    '900': '#8F1425',
    '1000': '#351519',
    'alpha-100': '#DB1A3533',
    'alpha-200': '#F2989E33',
};
export const blue = {
    '50': '#E4F3FF',
    '100': '#B9DBFA',
    '200': '#8CC5F7',
    '300': '#5EAFF3',
    '400': '#399EF2',
    '500': '#0C8EEF',
    '600': '#1080E1',
    '700': '#0E6DCE',
    '800': '#0C5DBC',
    '900': '#05398F',
    '1000': '#0D203F',
    'alpha-100': '#0E6DCE33',
    'alpha-200': '#8CC5F733',
};
export const green = {
    '50': '#E8F5E9',
    '100': '#C8E6C9',
    '200': '#9FF4A2',
    '300': '#73DC77',
    '400': '#60C764',
    '500': '#4CAF50',
    '600': '#43A046',
    '700': '#388E3C',
    '800': '#2E7D31',
    '900': '#1B5E20',
    '1000': '#1A2E1A',
    'alpha-100': '#43A04633',
    'alpha-200': '#A5D6A733',
};
export const orange = {
    '50': '#FFF3E0',
    '100': '#FFE0B2',
    '200': '#FFB830',
    '300': '#FAA80B',
    '400': '#FF9800',
    '500': '#FE8E26',
    '600': '#FF810D',
    '700': '#F57600',
    '800': '#EF6C00',
    '900': '#BD4D10',
    '1000': '#351E17',
    'alpha-100': '#EF6C0033',
    'alpha-200': '#FFCC8033',
};
export const pink = {
    '50': '#FCE4EC',
    '100': '#F8BACF',
    '200': '#F48FB1',
    '300': '#F06292',
    '400': '#EC407A',
    '500': '#E91E63',
    '600': '#D81B60',
    '700': '#C2185B',
    '800': '#AD1457',
    '900': '#880E4F',
    '1000': '#421E31',
    'alpha-100': '#E91E6333',
    'alpha-200': '#F48FB133',
};
export const cyan = {
    '50': '#E0F7FA',
    '100': '#B2EBF2',
    '200': '#80DEEA',
    '300': '#4DD0E1',
    '400': '#26C6DA',
    '500': '#00BCD4',
    '600': '#00ACC1',
    '700': '#0097A7',
    '800': '#00838F',
    '900': '#006064',
    '1000': '#062426',
    'alpha-100': '#00ACC133',
    'alpha-200': '#80DEEA33',
};
export const purple = {
    '50': '#EDE7F6',
    '100': '#D1C4E9',
    '200': '#B39DDB',
    '300': '#9575CD',
    '400': '#7E57C2',
    '500': '#673AB7',
    '600': '#5E35B1',
    '700': '#512DA8',
    '800': '#4527A0',
    '900': '#311B92',
    '1000': '#1D1838',
    'alpha-100': '#673AB733',
    'alpha-200': '#B39DDB33',
};
export const neutral = {
    '00': '#FFFFFF',
    '100': '#F7F8F9',
    '200': '#F1F2F4',
    '300': '#DCDFE4',
    '400': '#B3B9C4',
    '500': '#8590A2',
    '600': '#758195',
    '700': '#626F86',
    '800': '#44546F',
    '900': '#2C3E5D',
    '1000': '#172B4D',
    '1100': '#091E42',
    '-100-d': '#101214',
    '00-d': '#161A1D',
    '100-d': '#1D2125',
    '200-d': '#22272B',
    '300-d': '#2C333A',
    '400-d': '#454F59',
    '500-d': '#596773',
    '600-d': '#738496',
    '700-d': '#8696A7',
    '800-d': '#9FADBC',
    '900-d': '#B6C2CF',
    '1000-d': '#C7D1DB',
    '1100-d': '#DEE4EA',
    '100a': '#00000008',
    '200a': '#0000000F',
    '300a': '#00000024',
    '400a': '#0000004F',
    '500a': '#0000007D',
    '-100a-d': '#03040442',
    '100a-d': '#FFFFFF0A',
    '200a-d': '#FFFFFF14',
    '300a-d': '#FFFFFF26',
    '400a-d': '#FFFFFF45',
    '500a-d': '#FFFFFF6B',
};
export const grey = {
    '00': '#758195',
};
